import React from 'react';
import { Typography, Button, Modal } from '@scale/scaleui';

interface TaskerScreeningAuditPermissionRoleArchiveModalProps {
  open: boolean;
  onClose: () => void;
  onPublish: () => void;
}

const TaskerScreeningAuditPermissionRoleArchiveModal: React.FC<
  TaskerScreeningAuditPermissionRoleArchiveModalProps
> = ({ open, onClose, onPublish }) => {
  return (
    <Modal
      actions={
        <div className="flex items-center gap-2 justify-end">
          <Button
            variant="danger"
            onClick={() => {
              onPublish();
            }}
          >
            Archive
          </Button>
        </div>
      }
      open={open}
      onClose={onClose}
      theme="scale-theme"
      title="Audit Permission Role Archival"
      innerClassName="overflow-y-auto"
    >
      <div className="mt-4 mb-2">
        <Typography.Paragraph2>Are you sure? This cannot be undone.</Typography.Paragraph2>
      </div>
    </Modal>
  );
};

export default TaskerScreeningAuditPermissionRoleArchiveModal;
